import { render, staticRenderFns } from "./PlatformContracts.vue?vue&type=template&id=0f66317c&scoped=true&"
import script from "./PlatformContracts.vue?vue&type=script&lang=js&"
export * from "./PlatformContracts.vue?vue&type=script&lang=js&"
import style0 from "./PlatformContracts.vue?vue&type=style&index=0&id=0f66317c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66317c",
  null
  
)

export default component.exports